<template>
  <div class="transactions-wrapper">
    <el-table :data="tableData" :header-cell-style="rowClass">
      <el-table-column
        v-for="(column, index) in dynamicColumns"
        :key="index"
        :label="column.label"
        :prop="column.prop"
        :width="column.width"
      >
        <template slot-scope="scope">
          {{ scope.row[column.prop] }}
        </template>
        <template slot-scope="scope">
          <template v-if="column.label === '交易时间'">
            <div class="created-time">{{ scope.row[column.prop] }}</div>
            <!-- <div :style="{ width: column.width + 'px' }" class="created-time">{{ scope.row[column.time] }}</div> -->
          </template>

          <template v-if="column.label === '交易'">
            <div class="tx-box">
              <div class="tx-id">{{ scope.row[column.txId] }}</div>
              <div class="tx-name">
                交易发送者：<span class="sp1">{{ scope.row[column.orgId] }}</span>
              </div>
              <div class="tx-height">
                所属区块高度：<span class="sp2">{{ scope.row[column.blockHeights] }}</span>
              </div>
            </div>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import '@/styles/compatible/index.scss'

export default {
  name: 'Transactions',
  components: {},
  data() {
    return {
      intervalId: null,
      designWidth: 1920, // 设计稿宽度
      designHeight: 1080, // 设计稿高度
      baseFontSize: 16, // 基准字体大小
      ratio: 0.5625, // 高宽比（即 9/16）
      columns: [
        { label: '交易时间', prop: 'timestamp', cellClassName: 'tx-name', width: '80px' },
        {
          label: '交易',
          prop: 'id',
          txId: 'txId',
          blockHeights: 'blockHeight',
          orgId: 'orgId',
          width: '300px',
          blockHeight: 'blockheight',
          cellClassName: 'tx-id'
        }
      ],
      tableData: [],
      pageData: {
        page: 1,
        page_size: 100,
        total: 100
      }
    }
  },
  computed: {
    dynamicColumns() {
      const baseWidth = 1920
      const currentWidth =
        window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      const scaleRatio = currentWidth / baseWidth
      return this.columns.map(column => ({
        ...column,
        width: `${parseFloat(column.width) * scaleRatio}vw`
      }))
    },
    dynamicHeight() {
      const baseHeight = 300 // 设计稿高度为 300px
      const baseWidth = 1920 // 设计稿宽度为 1920px
      const currentWidth =
        window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      const scaleRatio = currentWidth / baseWidth
      return `${baseHeight * scaleRatio}vw` // 将像素高度转换为 vw 单位
    }
  },
  watch: {
    '$store.state.home.chainCid'(newValue) {
      if (newValue) this.getNewTxListFn()
    }
  },
  mounted() {
    this.getNewTxListFn()
    this.intervalId = setInterval(() => {
      this.getNewTxListFn()
    }, 10000)
  },
  methods: {
    // 获取最新交易
    ...mapActions(['getTxnLists']),
    getNewTxListFn() {
      let cid = this.$store.state.home.chainCid

      let params = {
        offset: 1,
        limit: 10,
        // chainId: this.$store.state.home.chainCid
        chainId: cid
      }

      this.getTxnLists(params).then(res => {
        res.items.forEach(item => {
          item.createAt = item.createAt.substring(5, 19).replace('T', '  ')
          item.timestamp = item.timestamp.split(' ')[1]
        })
        this.tableData = res.items.slice(0, 3)
        this.$store.commit('updateLoading', false)
      })
    },
    handleCurrentChange(page) {
      this.pageData.page = page
      this.getList()
    },
    rowClass({ row, rowIndex }) {
      return 'background:none;border:none;color:#00CBFF!important;;text-align:right;'
    },
    $px2vw(property, value, base = 1920) {
      const numValue = parseFloat(value)
      if (typeof numValue === 'number' && !isNaN(numValue)) {
        return `${(numValue / base) * 100}vw`
      }
      return value
    },
    formatTime(time) {
      const date = new Date(time)
      return date
        .toLocaleString()
        .replace(/\//g, '-')
        .replace(/\b\d\b/g, '0$&') // 转换为本地时间字符串
    }
  },
  destroyed() {
    // 清除定时器和图表实例
    clearInterval(this.intervalId)
    this.chart.dispose()
  }
}
</script>

<style scoped lang="scss">
@import '~@/styles/compatible/index.scss';

:root {
  --design-width: 1920px;
}

.defaultTheme .el-table th.el-table__cell > .cell {
  @include px2vw(font-size, 14);
}

.created-time {
  color: #fff;
  text-align: right;
  @include px2vw(font-size, 14);
}

.el-table__header {
  // @include px2vw(width, 407)
}

.tx-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  @include px2vw(font-size, 14);
  @include px2vw(height, 56);

  .tx-id {
    width: 100%;
    color: #b7cffc;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: right;
    overflow: hidden;
  }

  .tx-name {
    width: 50%;
    text-align: left;
    color: #b7cffc;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    span {
      color: #27dfed;
    }
  }

  .tx-id {
    text-align: right;
  }

  .tx-height {
    width: 50%;
    text-align: right;
    color: #b7cffc;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    span {
      color: #27dfed;
    }
  }
}

.transactions-wrapper {
  @include px2vw(width, 407);
  @include px2vw(height, 226);
  overflow: auto;
  @include px2vw(margin-left, 177);
  color: #00cbff !important;
}

.defaultTheme .el-table th.el-table__cell {
  background-color: none !important;
}

.header-row {
  background: none !important;
}

th {
  background: none !important;
}

.el-table th.el-table__cell {
  background-color: none !important;
}

.transaction-wrapper {
  padding: 20px;
}

.header-row .cell {
  background-color: transparent !important;
}

.is-leaf el-table__cell {
  background-color: transparent !important;
}

/deep/ .el-table__header-wrapper {
  background: none !important;
}

/deep/ .defaultTheme .el-table th.el-table__cell {
  background-color: none !important;
}

/deep/ .defaultTheme .el-table tr {
  background: none !important;
  text-align: right;
  // @include px2vw(height, 30);
}

/deep/ .el-table .has-gutter tr:nth-of-type(1) {
  background: none !important;
  @include px2vw(height, 40, true);
}

/deep/ .el-table tr {
  background: none !important;

  @include px2vw(height, 56, true);
}

.el-table__header-wrapper th {
  background: none !important;
}

/deep/ .el-table {
  background: none !important;
}

/deep/ .has-gutter .cell {
  @include px2vw(font-size, 14);
  @include px2vw(line-height, 58);
  @include px2vw(height, 58);
}

/deep/ .el-table__cell {
  padding: 0 !important;
}

/deep/ .el-table__body td {
  background: none !important;
  border: none !important;
  margin: 0;
  padding: 0;
}

.defaultTheme .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  border: none;
}

/deep/ .darkTheme .el-table th.el-table__cell {
  background: none !important;
}

.defaultTheme .el-table--group::after,
.defaultTheme .el-table--border::after,
.defaultTheme .el-table::before,
.darkTheme .el-table--group::after,
.darkTheme .el-table--border::after,
.darkTheme .el-table::before {
  height: 0 !important;
}
</style>
